import { gql } from '@apollo/client';

// get the user specific site names from Users table without sending the email from front-end, get the email from the supertoken context in the backend directly (use this query for security purpose)
// const getSitesListsQuery = gql`
//   query getInstallSites {
//     getInstallSites {
//       sitename
//       firstcontact
//     }
//   }
// `;

//get the user specific site names from Users table.
const getSitesListsQuery = gql`
  query getSitesLists($user_email: String!) {
    core_Users(where: {user_email: {_eq: $user_email}}) {
      tenant
    }
  }
`;

// const getSitesListsQuery = gql`
// query MyQuery {
//     install_Sites {
//       Site_Sku {
//         name
//       }
//       sitename
//       firstcontact
//       Site_Customers {
//         customer_name
//       }
//     }
//   }  
// `;

const countCensusDevice = gql`
  query countCensusDevice($siteName: String!) {
    countCensusDevice(siteName: $siteName)
  }
`;

const countCensusDeviceWithBornDate = gql`
  query countCensusDeviceWithBornDate($siteName: String!, $bornFromDate: Int!) {
    countCensusDeviceWithBornDate(siteName: $siteName, bornFromDate: $bornFromDate)
  }
`;

// const getSitesDeviceQuery = gql`
//   query getSitesDevice ($siteName: String!) {
//     install_Sites {
//       InstallSite_coreCensus(where: {site: {_eq: $siteName}}) {
//         site
//         host
//         os
//         born
//       }
//     }
//   }
// `;
const getSitesDeviceQuery = gql`
  query getSitesDevice ($siteName: String!) {
    install_Sites(where: {sitename: {_eq: $siteName}}) {
      site
      host
      os
      born
    }
  }
`;

const getSitesDevice1dayQuery = gql`
  query getSitesDeviceOfday ($siteName: String!, $bornYesDate:Int!, $bornTdyDate:Int!) {
    InstallSite_coreCensus(where: {site: {_eq: $siteName}, born: {_gte: $bornYesDate, _lte: $bornTdyDate}}) {
      Census{
        site
        host
        site
        os
        born
      }
    }
  }
`;


const getSitesDevicethirtydayQuery = gql`
  query getSitesDevicethirtyday ($siteName: String!, $bornthirtyDate:Int!, $bornTdyDate:Int!) {
    InstallSite_coreCensus(where: {site: {_eq: $siteName}, born: {_gte: $bornthirtyDate, _lte: $bornTdyDate}}) {
      Census{
        site
        host
        site
        os
        born
      }
    }
  }
`;


const getSitesDeviceninetyQuery = gql`
  query getSitesDeviceninety ($siteName: String!, $bornninetyDate:Int!, $bornTdyDate:Int!) {
    InstallSite_coreCensus(where: {site: {_eq: $siteName}, born: {_gte: $bornninetyDate, _lte: $bornTdyDate}}){
      Census{
        site
        host
        site
        os
        born
      }
    }
  }
`;

// get all sites list from site database install_Sites table
const getSitesListsFromSiteQuery = gql`
query getSitesListsFromSite {
    install_Sites_Customers {
      sitename
    }
  }  
`;

export { getSitesListsFromSiteQuery, getSitesListsQuery, getSitesDeviceQuery, getSitesDevice1dayQuery, getSitesDevicethirtydayQuery, getSitesDeviceninetyQuery, countCensusDevice, countCensusDeviceWithBornDate }
